export default __webpack_public_path__ + "ddae1a5a3821d2b0f7e3b29823558aed.svg";